import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { MESSAGES } from '../../utils/constants';

interface ConfirmDeleteModalProps {
  type: 'fiat' | 'soup' | 'exchange';
  itemName?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
  type,
  itemName,
  onConfirm,
  onCancel,
}) => {
  const getTitle = () => {
    switch (type) {
      case 'fiat':
        return 'Удалить валюту';
      case 'soup':
        return 'Удалить суп';
      case 'exchange':
        return 'Удалить биржу';
      default:
        return 'Подтвердите удаление';
    }
  };

  const getContent = () => {
    const itemText = itemName ? ` "${itemName}"` : '';
    
    switch (type) {
      case 'fiat':
        return `${MESSAGES.CONFIRM.DELETE_FIAT}${itemText ? ` (${itemName})` : ''}`;
      case 'soup':
        return `${MESSAGES.CONFIRM.DELETE_SOUP}${itemText ? ` (${itemName})` : ''}`;
      case 'exchange':
        return `${MESSAGES.CONFIRM.DELETE_EXCHANGE}${itemText ? ` (${itemName})` : ''}`;
      default:
        return 'Вы уверены, что хотите удалить этот элемент?';
    }
  };

  Modal.confirm({
    title: getTitle(),
    icon: <ExclamationCircleOutlined />,
    content: getContent(),
    okText: 'Удалить',
    okType: 'danger',
    cancelText: 'Отмена',
    onOk: onConfirm,
    onCancel: onCancel,
    centered: true,
  });

  return null;
};

export default ConfirmDeleteModal;
